var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dashboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dashboard"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600,
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.3,
    y: 2.3,
    width: 597.7,
    height: 597.7,
    rx: 86.32,
    fill: "#00a0df"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.22,
    y: 94.76,
    width: 109.22,
    height: 109.22,
    rx: 25,
    fill: "#bfebff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.77,
    y: 94.33,
    width: 109.22,
    height: 109.22,
    rx: 25,
    fill: "#bfebff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.26,
    y: 95.03,
    width: 109.22,
    height: 109.22,
    rx: 25,
    fill: "#bfebff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.93,
    y: 245.31,
    width: 109.22,
    height: 109.22,
    rx: 25,
    fill: "#bfebff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.77,
    y: 245.31,
    width: 109.22,
    height: 109.22,
    rx: 25,
    fill: "#bfebff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.97,
    y: 245.59,
    width: 109.22,
    height: 109.22,
    rx: 25,
    fill: "#bfebff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.93,
    y: 396.57,
    width: 109.22,
    height: 109.22,
    rx: 25,
    fill: "#bfebff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.77,
    y: 396.84,
    width: 109.22,
    height: 109.22,
    rx: 25,
    fill: "#bfebff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.97,
    y: 396.84,
    width: 109.22,
    height: 109.22,
    rx: 25,
    fill: "#bfebff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.cc57a65764bcaa2087ba0dfde1c5e626.svg";
export { ForwardRef as ReactComponent };